module.exports = "/images/cissa-marketplace.png?754dd9bf691e2a4697239879a3c7389a";